<template>
    <system-tabs :tabs="tabs">
        <template slot="help">
            <helpTable/>
            <helpMailSend/>
        </template>

        <template slot="w1">
            <MailSendForm disabled :to="to" :theme="theme" :content="content" @submit="onSend">
                <template slot="content">
                    <textarea v-model="message" class="my-textarea"></textarea>
                </template>
            </MailSendForm>
        </template>

        <template slot="w2">
            <InterfaceTable @search="onSearch" :headers="table.headers" :data="table.data" with-index/>
        </template>
    </system-tabs>
</template>

<script>
    import InterfaceTable from '@/components/interface/table'
    import SystemTabs from '@/components/system/tabs'
    import MailSendForm from '@/components/interface/mail/send-form.vue'

    import helpMailSend from '@/components/interface/mail/help-send'
    import helpTable from '@/components/interface/table/help'

    import data from './_data.json'

    export default {
        components: {
            InterfaceTable,
            SystemTabs,
            MailSendForm,
            helpMailSend,
            helpTable
        },
        data () {
            return {
                to: 'evgeny.pet@mail.ru',
                theme: 'Реквизиты',
                content: 'Добрый день, уважаемый Евгений!<br> От лица банка «ГОРМЕТБАНКА» благодарим Вас за оказанное доверие.<br>Вы запрашивали информацию о собственном счете.<br>Ваши реквизиты: <br><br><br><br><br><br><br><br><br><br><br><br>--------------------------<br>С уважением, <br>Георгий Долохов <br>Сотрудник по работе с клиентами <br>«ГОРМЕТБАНКА»',
                message: '',
                actions: {
                    useSearch: true,
                    success: false
                },
                tabs: [
                    {
                        title: 'Электронная почта',
                        name: 'email',
                        slot: 'w1'
                    },
                    {
                        title: 'База данных клиентов ГОРМЕТБАНКА',
                        name: 'table',
                        slot: 'w2'
                    }
                ],
                table: data.table
            }
        },
        methods: {
            onSend () {
                let message = this.message.trim()
                this.actions.success = (message === '7431806235788')
                this.$store.dispatch('questions/answer', this.actions)
            },

            onSearch (text) {
                let result = false
                if (text && text.length > 2) {
                    let regexp = new RegExp(text, 'i')
                    if ('Чернов Евгений'.search(regexp) > -1) {
                        result = true
                    }
                }
                this.actions.useSearch = result
            },

            // Завершение теста
            // Выполнение необходимых действий перед
            // переходом к следующему заданию / этипу
            finish () {}
        }
    }
</script>

<style lang="stylus" scoped>
    .my-textarea {
        position absolute
        top 50px
        outline none
        padding-top 80px
        left 10px
        width 98%
        resize none
        height 380px
        right 10px
    }
</style>
